// TODO: (MVP-1132): these types should be generated automatically based on the API's Swagger documentation
import { INDICATOR } from '@/api/rest/resources/types/IndicatorProduct';

export type IndicatorProductNamesForDataExport = {
  id: string;
  name: string;
  indicator_products: Array<{ id: string; name: string }>;
};

export type PaginatedIndicatorProductNamesForDataExportList = {
  count: number;
  next: string | null;
  previous: string | null;
  results: IndicatorProductNamesForDataExport[];
};

/**
 * GET /api/v1/reports/subscribed_indicators/
 */
export const GET_REPORTS_SUBSCRIBED_INDICATORS_PATH = 'reports/subscribed_indicators';
export type GetReportsSubscribedIndicatorsRequestPathVariables = undefined;
export type GetReportsSubscribedIndicatorsRequestQueryParams = {
  organization_id: string;
  limit?: number;
  offset?: number;
};
export type GetReportsSubscribedIndicatorsSuccessDto = PaginatedIndicatorProductNamesForDataExportList;
export type GetReportsSubscribedIndicatorsErrorDto = Error;

/**
 * GET /api/v1/reports/export_facts/
 */
export const GET_REPORTS_EXPORT_FACTS_PATH = 'reports/export_facts';
export type GetReportsExportFactsRequestPathVariables = undefined;
export type GetReportsExportFactsRequestQueryParams = {
  organization_id: string;
  fact_name: string;
  plot_group_id?: string;
};
export type GetReportsExportFactsSuccessDto = Blob; // Excel file response
export type GetReportsExportFactsErrorDto = Error;

/**
 * Type definition for a FileInfo object from the backend.
 */
export type FileInfo = {
  id: string;
  visible_filename: string;
  content_type: string;
};

export const AutomatedReportStatus = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  FAILED: 'failed',
} as const;

export type AutomatedReportStatusType = (typeof AutomatedReportStatus)[keyof typeof AutomatedReportStatus];

/**
 * Type definition for an AutomatedReport object from the backend.
 */
export type AutomatedReport = {
  id: string;
  organization: string;
  report_type: string;
  status: AutomatedReportStatusType;
  file_info: FileInfo | null;
  download_url: string | null;
  error_message?: string | null;
  created_at: string;
  updated_at: string;
};

export const REPORT_TYPES = {
  MANUAL_REPORT: 'manual_report',
  CARBON_SUMMARY: 'carbon_summary',
  BIODIVERSITY_SUMMARY: 'biodiversity_summary',
  LANDSCAPE_SUMMARY: 'landscape_summary',
  WATER_SUMMARY: 'water_summary',
} as const;

export const CSV_REPORT_TYPES = {
  CARBON_CSV: 'carbon_csv',
  LANDSCAPE_CSV: 'landscape_csv',
  WATER_CSV: 'water_csv',
  SOIL_CSV: 'soil_csv',
  BIODIVERSITY_CSV: 'biodiversity_csv',
} as const;

export type CsvReportType = (typeof CSV_REPORT_TYPES)[keyof typeof CSV_REPORT_TYPES];

/**
 * GET /api/v1/reports/organization/{organization_id}/automated-reports/
 * Fetches a list of automated reports for a given organization.
 */
export const GET_ORGANIZATION_AUTOMATED_REPORTS_PATH = 'reports/organization/{organization_id}/automated-reports/';
export type GetOrganizationAutomatedReportsRequestPathVariables = {
  organization_id: string;
};
export type GetOrganizationAutomatedReportsRequestQueryParams = undefined;
export type GetOrganizationAutomatedReportsSuccessDto = {
  count: number;
  next: string | null;
  previous: string | null;
  results: AutomatedReport[];
};
export type GetOrganizationAutomatedReportsErrorDto = Error;

/**
 * POST /api/v1/reports/organization/{organization_id}/generate-report/
 */
export const POST_ORGANIZATION_GENERATE_REPORT_TYPE_PATH =
  'reports/organization/{organization_id}/generate_report/{report_type}/';
export type PostOrganizationGenerateReportRequestTypePathVariables = {
  organization_id: string;
  report_type: (typeof REPORT_TYPES)[keyof typeof REPORT_TYPES];
};
export type PostOrganizationGenerateReportTypeRequestBodyData = {
  plot_group_id?: string;
};
export type PostOrganizationGenerateReportTypeSuccessDto = AutomatedReport;
export type PostOrganizationGenerateReportTypeErrorDto = Error;

/**
 * GET /api/v1/reports/organization/{organization_id}/available_csv_exports/
 */
export const GET_AVAILABLE_CSV_EXPORTS_PATH = 'reports/organization/{organization_id}/available_csv_exports/';

export type AvailableCsvExport = {
  report_type: string;
  report_name: string;
  indicator_products: string[];
};

export type GetAvailableCsvExportsRequestPathVariables = {
  organization_id: string;
};
export type GetAvailableCsvExportsSuccessDto = {
  results: AvailableCsvExport[];
};
export type GetAvailableCsvExportsErrorDto = Error;

/**
 * GET /api/v1/reports/organization/{organization_id}/available_automated_reports/
 */
export const GET_AVAILABLE_AUTOMATED_REPORTS_PATH =
  'reports/organization/{organization_id}/available_automated_reports/';
export type GetAvailableAutomatedReportsRequestPathVariables = {
  organization_id: string;
};
export type GetAvailableAutomatedReportsSuccessDto = {
  results: {
    report_type: (typeof REPORT_TYPES)[keyof typeof REPORT_TYPES];
    indicator_products: (typeof INDICATOR)[keyof typeof INDICATOR][];
  }[];
};
export type GetAvailableAutomatedReportsErrorDto = Error;

/**
 * POST /api/v1/reports/organization/{organization_id}/export_report_csv/{report_type}/
 */
export const POST_EXPORT_REPORT_CSV_PATH = 'reports/organization/{organization_id}/export_report_csv/{report_type}/';

export type PostExportReportCsvRequestPathVariables = {
  organization_id: string;
  report_type: string;
};
export type PostExportReportCsvRequestQueryParams = undefined;
export type PostExportReportCsvRequestBodyData = {
  plot_group_id?: string;
};
export type PostExportReportCsvSuccessDto = AutomatedReport;
export type PostExportReportCsvErrorDto = Error;

/**
 * GET /api/v1/reports/automated-reports/{report_id}/
 * Fetches a single AutomatedReport by ID (includes SUCCESS/FAILED).
 */
export const GET_AUTOMATED_REPORT_DETAIL_PATH = 'reports/automated-reports/{report_id}/';
export type GetAutomatedReportDetailRequestPathVariables = {
  report_id: string;
};
export type GetAutomatedReportDetailSuccessDto = AutomatedReport;
export type GetAutomatedReportDetailErrorDto = Error;
